import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content"
}
const _hoisted_2 = {
  id: "update-contact-information-form",
  class: "form update-contact-information gap-4",
  method: "post"
}
const _hoisted_3 = { class: "w-100 d-flex flex-column gap-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "w-100" }, " Phone Number ", -1)
const _hoisted_5 = { class: "d-flex justify-content-between gap-10 col-md-6 col-sm-8 flex-md-row flex-column w-sm-100" }
const _hoisted_6 = { class: "d-flex flex-md-row align-items-center flex-column gap-10" }
const _hoisted_7 = { class: "radio-group w-auto" }
const _hoisted_8 = { class: "radio-buttons" }
const _hoisted_9 = { class: "radio-button" }
const _hoisted_10 = ["id", "onUpdate:modelValue", "onChange", "checked"]
const _hoisted_11 = ["for"]
const _hoisted_12 = { class: "btn-delete" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "w-full"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-plus" })
], -1)
const _hoisted_16 = {
  key: 1,
  class: "w-100 d-flex flex-column"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h4", { class: "w-100" }, " Account E-mail Address ", -1)
const _hoisted_18 = { class: "inputs-wrapper" }
const _hoisted_19 = {
  key: 2,
  class: "w-100 d-flex flex-column gap-10"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h4", { class: "w-100" }, " Alternate Web Email Address", -1)
const _hoisted_21 = { class: "radio-group w-auto" }
const _hoisted_22 = { class: "radio-buttons" }
const _hoisted_23 = { class: "radio-button" }
const _hoisted_24 = ["id", "onUpdate:modelValue", "checked", "onChange"]
const _hoisted_25 = ["for"]
const _hoisted_26 = { class: "btn-delete" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "w-full pdt-10" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-plus" })
], -1)
const _hoisted_30 = { class: "action-buttons sm-pdr-0 sm-pdl-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Alerts, {
      success: _ctx.success,
      info: _ctx.info,
      errors: _ctx.errors,
      onReset: _ctx.resetAlerts
    }, null, 8, ["success", "info", "errors", "onReset"]),
    _createVNode(_component_MessageCard, {
      message: "Enter the information you wish to update in the applicable field. These changes automatically update your account.",
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card_full"
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("form", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profileStore.phones, (phone, key) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: key,
                  class: "inputs-wrapper flex-nowrap align-items-center justify-content-start"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_SelectComponent, {
                      selectedOption: phone.TypeCode,
                      "onUpdate:selectedOption": ($event: any) => ((phone.TypeCode) = $event),
                      options: _ctx.profileStore.phoneTypes,
                      "single-arrow": true,
                      customClass: "gap-0 col-md-4"
                    }, null, 8, ["selectedOption", "onUpdate:selectedOption", "options"]),
                    _createVNode(_component_TextInput, {
                      type: "text",
                      name: "phone",
                      placeholder: "333-333-3333",
                      max: 14,
                      modelValue: phone.ContactInfo,
                      "onUpdate:modelValue": ($event: any) => ((phone.ContactInfo) = $event),
                      required: true,
                      customClass: "gap-0 flex-grow-1 col-md-4"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: `PrimaryPhone${key + 1}`,
                            name: "Primary",
                            "onUpdate:modelValue": ($event: any) => ((phone.Primary) = $event),
                            onChange: ($event: any) => (_ctx.handlePrimaryChange(phone.CMIID)),
                            checked: phone.Primary
                          }, null, 40, _hoisted_10), [
                            [_vModelRadio, phone.Primary]
                          ]),
                          _createElementVNode("label", {
                            class: "body-text",
                            for: `PrimaryPhone${key + 1}`
                          }, " Primary ", 8, _hoisted_11)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("i", {
                        class: "iatse-icon-trash icon_delete plan-modal fs-4",
                        onClick: ($event: any) => (_ctx.handleDeleteAction('Phone', phone.CMIID))
                      }, null, 8, _hoisted_13)
                    ])
                  ])
                ]))
              }), 128))
            ]),
            (!_ctx.newPhoneAdded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("a", {
                    href: "",
                    class: "btn btn-add",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleAddPhone && _ctx.handleAddPhone(...args)), ["prevent"]))
                  }, [
                    _hoisted_15,
                    _createTextVNode(" Add New Phone Number ")
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.profileStore.userEmail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("small", {
                    class: "text-underline fs-xs mt-10 plan-modal",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('account-settings', 'Account Settings', 'plan-card-info plan-tables')))
                  }, " Account email can be changed in the Account Settings page."),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_TextInput, {
                      type: "email",
                      placeholder: "Enter Web Email Address",
                      max: 60,
                      modelValue: _ctx.profileStore.userEmail,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profileStore.userEmail) = $event)),
                      required: true,
                      readonly: true,
                      customClass: "disabled"
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.profileStore.emails.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profileStore.emails, (email, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "inputs-wrapper flex-nowrap align-items-center justify-content-start"
                    }, [
                      _createVNode(_component_TextInput, {
                        type: "email",
                        placeholder: "Enter Web Email Address",
                        max: 60,
                        modelValue: email.ContactInfo,
                        "onUpdate:modelValue": ($event: any) => ((email.ContactInfo) = $event),
                        required: true
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              id: `PrimaryEmail${key + 1}`,
                              name: "PrimaryEmail",
                              "onUpdate:modelValue": ($event: any) => ((email.Primary) = $event),
                              checked: email.Primary,
                              onChange: ($event: any) => (_ctx.handleEmailPrimaryChange(email.CMIID))
                            }, null, 40, _hoisted_24), [
                              [_vModelRadio, email.Primary]
                            ]),
                            _createElementVNode("label", {
                              class: "body-text",
                              for: `PrimaryEmail${key + 1}`
                            }, " Primary ", 8, _hoisted_25)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("i", {
                          class: "iatse-icon-trash icon_delete plan-modal fs-4",
                          onClick: ($event: any) => (_ctx.handleDeleteAction('Email', email.CMIID))
                        }, null, 8, _hoisted_27)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("a", {
                href: "",
                class: "btn btn-add",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.profileStore.addEmailAddress()), ["prevent"]))
              }, [
                _hoisted_29,
                _createTextVNode(" " + _toDisplayString('Alternate Email Address'))
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetModal && _ctx.resetModal(...args)), ["prevent"])),
                class: "btn btn-secondary"
              }, " Discard"),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitData && _ctx.submitData(...args)), ["prevent"])),
                class: "btn btn-primary"
              }, _toDisplayString(_ctx.loadingSubmit ? 'Saving...' : 'Save Changes'), 1)
            ])
          ])
        ]))
  ], 64))
}